<template>
  <div class="login-wrap">
    <div class="head-top">
      <img src="/static/images/logo.png"/>
      <span class="platform-name">锦胜雾森智慧雾森管理平台</span>
    </div>
    <div class="login">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
               class="demo-ruleForm login-container">
        <p class="title">手机号登录</p>
        <el-form-item prop="phone">
          <el-input type="text" v-model="ruleForm.phone" auto-complete="off" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input type="text" v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
          <div class="code"><span>|</span><span @click="getcode()">{{ codeText }}</span></div>
        </el-form-item>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">登录
          </el-button>
        </el-form-item>
        <el-checkbox v-model="agreement"></el-checkbox>
        <span class="agreement">阅读并接受<span @click="agreements()"> 用户协议</span> 和 <span
          @click="privacy()">隐私政策</span></span>
      </el-form>
    </div>

    <div class="banner">
      <el-carousel indicator-position="outside" height="52vh">
        <el-carousel-item v-for="(item,k) in banners" :key="k">
          <el-image :src="item" fit="cover"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <el-dialog :visible.sync="showAgreement" style="margin-top: -15vh;" width="100%" class="pop"
               @click="closeAgreementDialog">
      <h1>{{ agreementData.title }}</h1>
      <div v-html="agreementData.content"></div>
    </el-dialog>

    <el-dialog :visible.sync="showPrivacy" style="margin-top: -15vh;" width="100%" class="pop"
               @click="closePrivacyDialog">
      <h1>{{ privacyData.title }}</h1>
      <div v-html="privacyData.content"></div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import {agreements, getCodes, login, secret} from '../api/userMG'

export default {
  name: 'login',
  data() {
    return {
      logining: false,
      agreement: false,
      showAgreement: false,
      showPrivacy: false,
      ruleForm: {
        phone: '',
        code: '',
      },
      codeText: '获取验证码',
      canClick: true,
      second: 60,
      banners: [
        "/static/images/banner1.png",
        "/static/images/banner2.png",
        "/static/images/banner3.png",
      ],
      agreementData: {
        title: '',
        content: ''
      },
      privacyData: {
        title: '',
        content: ''
      },
      //rules前端验证
      rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {required: true, message: '请输入正确的手机号', trigger: 'blur', min: 11, max: 11}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {required: true, message: '请输入正确的验证码', trigger: 'blur', min: 6, max: 6}
        ]
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
  },
  // 里面的函数只有调用才会执行
  methods: {
    getcode() {
      let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.ruleForm.phone)) {
        this.$message({
          type: 'error',
          message: '请填写正确的手机号'
        })
        return false;
      }
      if (this.canClick) {
        getCodes({phone: this.ruleForm.phone, webType: 'frontend'}).then(res => {
            var ok = res && (res.code === 200 || res.code === '200')
            if (ok) {
              this.canClick = false
              this.codes = res.codes || (res.result && res.result.codes)
              this.$message({
                type: 'success',
                message: '发送成功'
              })
              this.timer()
            } else {
              this.$message({
                type: 'error',
                message: (res && res.message) ? res.message : '发送失败，请稍后重试'
              })
            }
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '发送失败，请检查网络或联系管理员'
            })
          })
      }
    },
    timer() {
      if (this.second > 0) {
        this.second--;
        this.codeText = this.second + "s";
        setTimeout(this.timer, 1000);
      } else {
        this.second = 0;
        this.codeText = "获取验证码";
        this.canClick = true;
      }
    },
    submitForm(formName) {
      let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.ruleForm.phone)) {
        this.$message({
          type: 'error',
          message: '请填写正确的手机号'
        })
        return false;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.agreement) {
            this.$message.error('请先阅读并接受相关协议')
            return false;
          }
          //this.logining = true
          login(this.ruleForm).then(res => {
            if (res.code == 200) {
              setTimeout(() => {
                this.logining = false
                // 缓存token
                window.localStorage.setItem('logintoken', res.result.token)
                // 缓存用户个人信息
                window.localStorage.setItem('userData', JSON.stringify(res.result.user))
                this.$store.commit('login', 'true')
                this.$router.push({path: '/home/index'})
              }, 1000)
            } else {
              this.$message.error(res.message)
              this.logining = false
              return false
            }
          })
        } else {
          this.logining = false
          return false
        }
      })
    },
    closeAgreementDialog() {
      this.showAgreement = false
    },
    closePrivacyDialog() {
      this.showPrivacy = false
    },
    agreements() {
      this.showAgreement = true
      agreements().then(res => {
        if (res.code == 200) {
          this.agreementData.title = res.result.agreement_title
          this.agreementData.content = res.result.agreement_content
        }
      })
    },
    privacy() {
      this.showPrivacy = true
      secret().then(res => {
        if (res.code == 200) {
          this.privacyData.title = res.result.secret_title
          this.privacyData.content = res.result.secret_content
        }
      })
    },
  }
}
</script>

<style scoped>
.login-wrap {
  width: 100%;
  height: 100%;
  background: url('/static/images/loginbg.png') no-repeat;
  background-size: cover;
}

.pop {
  position: absolute;
  top: 0px;
}

.head-top {
  padding-top: 4vh;
  display: flex;
  padding-left: 6vw;
}

.platform-name {
  margin-top: 1.5vh;
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 20px auto;
  text-align: left;
  color: #505458;
  font-weight: bold;
}

.agreement {
  margin: 0px 0px 35px 0px;
  font-size: 14px;
}

.agreement span {
  color: #0052D9;
}

.login {
  float: left;
  margin-top: 32vh;
  margin-left: 10vw;
}

.banner {
  width: 40vw;
  margin-top: 20vh;
  margin-left: 50vw;
}

/deep/ .el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: transparent;
  border: 1px solid #0052D9;
  border-radius: 50%;
  opacity: 0.5;
}

/deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #0052D9;
  border-radius: 50%;
  opacity: 1;
}

.code {
  position: absolute;
  margin-top: -40px;
  right: 10px;
  color: #0052D9;
}

.code span {
  padding-left: 5px;
}

h1 {
  margin-top: -5vh;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue